import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IDocumentService, IModule, ITimeoutService} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {WebNavigasjon} from "../../../../tjenester/WebNavigasjon";
import {MøteTjeneste} from "../../MøteTjeneste";
import {MøteDeltakerTjeneste} from "../../MøteDeltakerTjeneste";
import {MøteDatatjenesteForAjs} from "web/nedgraderteNg2Tjenester";
import {ng2RegNavn} from "web/nedgraderteNg2TjenesterRegisternavn";

export class MøteProsessHandlinger {

    static regNavn = 'wm.møte.MøteProsessHandlinger';

    static registrerTjeneste(angular: IModule) {
        angular.service(MøteProsessHandlinger.regNavn, MøteProsessHandlinger.forInjisering());
    }

    static forInjisering() {
        return [
            regNavn.ng.$timeout,
            regNavn.ng.$document,
            MøteTjeneste.regNavn,
            MøteDeltakerTjeneste.regNavn,
            ng2RegNavn.MøteDatatjenesteForAjs,
            WebNavigasjon.regNavn,
            MøteProsessHandlinger
        ];
    }

    constructor(private $timeout: ITimeoutService,
                private $document: IDocumentService,
                private møteTjeneste: MøteTjeneste,
                private møteDeltakerTjeneste: MøteDeltakerTjeneste,
                private møteDatatjenesteForAjs: MøteDatatjenesteForAjs,
    private webNavigasjon: WebNavigasjon) {
    }

    opprettSaker(moete: l.MøteModell) {
        this.webNavigasjon.gåTilMøte(moete.id)
            .then(() => {
                // En viss timeout er nødvendig, men satt den litt lengre fordi da får animasjonen fra gåTilMøte kjøre ferdig
                // før tekstfeltet fokuseres, som gjør at animasjonen blir enklere å følge med på
                this.$timeout(() => this.$document.find('#wmk-nss-ny-sak-input').focus(), 300);
            })
    }

    publiserMøtet(møte: l.MøteModell) {
       this.møteTjeneste.publiserMøtet(møte);
    }

    opphevPubliseringenAvMøtet(møte: l.MøteModellEnkel) {
        this.møteTjeneste.opphevPubliseringenAvMøtet(møte.id);
    }

    sendInnkalling(møte: l.MøteModellEnkel) {
        this.møteDeltakerTjeneste.sendInnkalling(møte);
    }

    godtaInnkalling(møte: l.MøteModellEnkel) {
        this.møteDatatjenesteForAjs.tjeneste().then(tjeneste => {
            tjeneste.godtaInnkalling(møte.id);
        });
    }

    avslåInnkalling(møte: l.MøteModellEnkel) {
        this.møteDatatjenesteForAjs.tjeneste().then(tjeneste => {
            tjeneste.avslåInnkalling(møte.id);
        });
    }

    skrivProtokoll(møte: l.MøteModellEnkel) {
        this.webNavigasjon.gåTilRedigerMøteProtokoll(møte.id);
    }

    publiserProtokoll(møte: l.MøteModell) {
        this.møteTjeneste.publiserProtokoll(møte);
    }

    opphevPubliseringenAvProtokollen(møte: l.MøteModellEnkel) {
        this.møteTjeneste.opphevPubliseringenAvProtokollen(møte.id);
    }

    sendTilSignering(møte: l.MøteModell) {
        this.møteTjeneste.sendProtokollTilSignering(møte);
    }

    signerProtokoll(møte: l.MøteModellEnkel) {
        // TODO: Denne går til signeringsfeltene, men spekken over sier vi skal åpne signerings-dialogen
        // sign dialog kan åpnes med DokumentsigneringDialog.visSignerDialog - men krever en del argumenter som pt blir beregnet i ProtokollSigneringKontroller
        // samt ymse callback som følge av signering gjennmført etc
        // utsetter av denne grunn (større endring) impl at åpning av modal - men løser det ved å scrolle til "signer" knappen på protokollsiden
        // der bruker selv kan klikke på "signer" for å åpne sign dialog.
        this.møteTjeneste.signerProtokoll(møte.id);
    }

    venterPåSignaturer(møte: l.MøteModellEnkel) {
        this.webNavigasjon.gåTilSignerMøteProtokoll(møte.id, false);
    }

    protokollFerdigSignert(møte: l.MøteModellEnkel) {
        this.webNavigasjon.gåTilSignerMøteProtokoll(møte.id, false);
    }

    duHarGodtattInnkallingen(møte: l.MøteModellEnkel) {
        // TODO: Åpne deltakerlisten, slik at det er enkelt å evt bytte svar
        // for komplisert - dagens "deltakerliste" aktiveres vhja mouse over og en åpning via annen mekanisme vil kreve en større endring
        // utettes derfor
    }

    duHarAvslåttInnkallingen(møte: l.MøteModellEnkel) {
        // TODO: Åpne deltakerlisten, slik at det er enkelt å evt bytte svar
        // for komplisert - dagens "deltakerliste" aktiveres vhja mouse over og en åpning via annen mekanisme vil kreve en større endring
        // utettes derfor
    }

    duHarSignertProtokollen(møte: l.MøteModellEnkel) {
        this.webNavigasjon.gåTilSignerMøteProtokoll(møte.id, false);
    }

}
